import React from 'react'
import { Box, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, Typography, Divider, Grid } from '@mui/material'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { useQuery } from '@tanstack/react-query';
import { getNpoDocuments } from '../../../Store/npoProfile/npoProfile';
import { enqueueSnackbar } from 'notistack'
import Loading from '../../../Components/Loader/Loading';
import { Link } from 'react-router-dom';

export default function Documents({ orgName, id }) {

  const { data: documents, isPending: documentsLoading } = useQuery({
    queryKey: ['documents', orgName],
    queryFn: () => getNpoDocuments(orgName),
    refetchOnWindowFocus: false,
    enabled: !!orgName
  });

  const email = localStorage.getItem('NpoToken');

  const handleViewFileClick = (e, base64Data, fileType = 'application/pdf') => {
    e.preventDefault();
    if (!email) {
      enqueueSnackbar('Please register or login to view.', { variant: 'error' });
      return;
    } else {
      try {
        // Construct the data URL dynamically based on the file type
        const dataUrl = `data:${fileType};base64,${base64Data}`;

        // Open the file in a new tab
        const newWindow = window.open();
        if (newWindow) {
          if (fileType.startsWith("image/")) {
            // For images, display in an <img> tag
            newWindow.document.write(`<img src="${dataUrl}" alt="Base64 Image" />`);
          } else if (fileType === "application/pdf") {
            // For PDFs, embed the file
            newWindow.document.write(`<embed src="${dataUrl}" width="100%" height="100%" type="${fileType}" />`);
          } else {
            // For other types, provide a download link
            newWindow.document.write(`
            <p>Click the link below to download the file:</p>
            <a href="${dataUrl}" download="file">Download File</a>
          `);
          }
        } else {
          console.error("Failed to open new window. Popup blocker may be active.");
        }
      } catch (error) {
        console.error("Error displaying file:", error);
      }
    }
  }

  return (
    <>
      <div id={id} >
        <Divider sx={{ color: '#E5E8EB', marginTop: '30px', borderBottomWidth: 3 }} />
        <Box sx={{ backgroundColor: '#004878', padding: '10px',marginTop:'30px', borderRadius: '15px', width: '50%', display: 'flex', alignItems: 'center' }}>
          <ParagraphComp text='Audited Financial Statements' className='text-[white] mt-[0px] mb-[0px] text-2xl  font-bold' />
        </Box>
        {(documents?.documents && documents?.documents?.length > 0) ?
          <>
            {documentsLoading ? <Box sx={{ mt: 5, px: 4, display: 'flex', justifyContent: 'center' }} > <Loading /></Box > : <Box sx={{ mt: 3 }}>
              <ParagraphComp text='Audited Accounts' className='text-[#004878] text-2xl mb-3 font-bold' />
              <ParagraphComp text='Registered users can view Audited Financial Statements if provided by the organisation.' className='text-[black] text-xl mb-3 font-bold' />
              <Table aria-label="collapsible table">
                <TableHead sx={{ background: '#EDF2F6' }}>
                  <TableRow>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Financial Year</TableCell>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Document Type</TableCell>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(documents?.documents && documents?.documents?.length > 0) ? documents?.documents?.map((item, index) =>
                    <TableRow key={index}>
                      <TableCell sx={{ fontSize: '16px' }} align="left">FY {item?.financial_year || '-'}</TableCell>
                      <TableCell sx={{ fontSize: '16px' }} align="left">{item?.file_type || '-'}</TableCell>
                      <TableCell align="left" sx={{ cursor: 'pointer', color: '#004878', fontSize: '16px' }} onClick={(e) => handleViewFileClick(e, item?.base64_file, item?.file_type?.toLowerCase() === 'pdf' ? 'application/pdf' : 'image/png')}>View </TableCell>
                    </TableRow>) : <Typography variant='h5' align='center'>--------</Typography>}
                </TableBody>
              </Table>
              <p className='text-[black] text-base mb-3 font-semibold mt-3'>
                Legal, financial, policy and other documents may be stored voluntarily by the organisation in its profile. These could be made available with the organisation's consent to subscribed users on specific request, subject to terms & conditions.  For details, <Link to="/contact" className='text-blue-600' > contact us.</Link> 
              </p>
            </Box>
            }
          </>
          :
          <>
            < ParagraphComp text='No data provided for this section.' className='text-[black] text-xl mt-[20px] font-thin' />
            <p className='text-[black] text-base mb-3 font-semibold mt-3'>
            Legal, financial, policy and other documents may be stored voluntarily by the organisation in its profile. These could be made available with the organisation's consent to subscribed users on specific request, subject to terms & conditions.  For details, <Link to="/contact" className='text-blue-600' > contact us.</Link> 
            </p>
          </>
        }
      </div>
    </>
  )
}
